// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6ap8o","headerBtn":"styles_headerBtn__INc2f"};